// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"userFileMessage_mainContainer__bP9aw","userImg":"userFileMessage_userImg__1ki-g","messageContainer":"userFileMessage_messageContainer__1mswT"};